/**
 * Service: posConfigOptions
 */
angular.module('acme.common.service.posConfigOptions', [])
.service('PosConfigOptionsService', [function() {

    return {

      model: {
        configId: '',
        name: '',
        description: '',
        orderListResultCountLimit: 50,
        apiTimeoutInSecs: 60,
        passcodes: [],
        cacheRefreshIntervalInSecs: 300,
        displayBrightnessPercent: 50
      },
      
      init: function() {
        return true;
      },

      setModel: function(model) {
        this.model = (model) ? model : {};
      },

      getModel: function() {
        return this.model;
      },

      hasPasscodes: function() {
        return (this.model.passcodes instanceof Array && this.model.passcodes.length);
      },

      newPasscode: function(props) {
        return {
          type: props.type,
          length: props.length,
          code: props.code
        };
      }

    };

}]);